// extracted by mini-css-extract-plugin
module.exports = {"section":"CartPage_section__zxCVQ","totalcost":"CartPage_totalcost__6ZE5x","emptyCart":"CartPage_emptyCart__3apm9","orderBtn":"CartPage_orderBtn__2LQOZ"};